import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppDialogUiReduxObject, ConfirmationDialogButton, ConfirmationDialogComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'sl-lpms-form-scan-pending-confirmation-dialog',
  templateUrl: './form-scan-pending-dialog.component.html',
  styleUrls: ['./form-scan-pending-dialog.component.scss']
})
export class FormScanPendingDialogComponent extends ConfirmationDialogComponent {
  static ClassId = 'FormScanPendingDialogComponent_f7b8d327-2633-4e2d-ab5d-a13e505263e9';
  ConfirmationDialogButton = ConfirmationDialogButton;

  form: FormGroup;
  constructor(dialogReduxObject: AppDialogUiReduxObject, bsModalService: BsModalService, store: Store<any>, actions: Actions, bsModalRef: BsModalRef) {
    super(dialogReduxObject, bsModalService, store, actions, bsModalRef);
  }
}
